'use strict';

/**
 * Change the legal function urls
 */
let $language = $('#language');
let $country = $('#country');

function changeLegalLinks() {
    let $form = $('#form-register');
    let language = $language.selectpicker('val');
    let country = $country.selectpicker('val');

    if (!language) {
        language = $form.data('language');
    }

    if (!country) {
        country = $form.data('country');
    }

    let privacyUrl = $form.data('privacy') + '/' + language + '-' + country;
    let termsUrl = $form.data('terms') + '/' + language + '-' + country;
    let agbUrl = $form.data('agb') + '/' + language + '-' + country;
    let imprintUrl = $form.data('imprint') + '/' + language + '-' + country;

    // Set links for cookie statement
    $('#privacy-cookie-statement').attr('href', privacyUrl);

    // Set links for terms
    $('#register-terms').attr('href', agbUrl);
    $('#register-terms-use').attr('href', termsUrl);
    $('#register-privacy').attr('href', privacyUrl);

    // Set links for footer
    $('#footer-agb').attr('href', agbUrl);
    $('#footer-privacy').attr('href', privacyUrl);
    $('#footer-terms').attr('href', termsUrl);
    $('#footer-imprint').attr('href', imprintUrl);
}

/**
 * language select picker change
 */
$language.on('changed.bs.select', function () {
    changeLegalLinks();
});

/**
 * country select picker change
 */
$country.on('changed.bs.select', function () {
    changeLegalLinks();
});